// actions.js
import * as actionTypes from "./actionsTypes";

export const setValuePexpl = (value) => ({
  type: actionTypes.SET_VALUE_Pexpl,
  payload: value,
});

export const setTypePexpl = (type) => ({
  type: actionTypes.SET_TYPE_Pexpl,
  payload: type,
});
export const setActifPexpl = (actif) => ({
  type: actionTypes.SET_ACTIF_Pexpl,
  payload: actif,
});

export const setCurrentPagePexpl = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_Pexpl,
  payload: page,
});

export const setOrderPexpl = (order) => ({
  type: actionTypes.SET_ORDER_Pexpl,
  payload: order,
});

export const setSortFieldPexpl = (field) => ({
  type: actionTypes.SET_SORT_FIELD_Pexpl,
  payload: field,
});
